/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../components/_utils/CommonToast";
import SvgComponent from "../../../components/_utils/SVGComponent";
import InternalTxnRecreateAdditionalDetails from "../../../components/InternalTransactionMain/InternalReCreateTxn/InternalTxnRecreateAdditionalDetails";
import InternalTxnAdditionalDetails from "../../../components/InternalTransactionMain/InternalTxnAdditionalDetails";
import InternalTxnAmount from "../../../components/InternalTransactionMain/InternalTxnAmount";
import InternalTxnConfirm from "../../../components/InternalTransactionMain/InternalTxnConfirm";
import InternalTxnSelectAccount from "../../../components/InternalTransactionMain/InternalTxnSelectAccount";
import RefactorInternalTxnAmount from "../../../components/InternalTransactionMain/RefactorIntenalTxnAmount";
import RefactorInternalTxnSelectAccount from "../../../components/InternalTransactionMain/RefactorIntenalTxnSelectAccount";
import {
  beneCategories,
  resetViewAllAcc,
  uploadImages,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { viewInternalAccountDetail } from "../../../redux/features/internalApi/internalApi";
import {
  internalTransactionCreate,
  internalTransactionRecreate,
} from "../../../redux/features/internalTransaction/internalTransactionCreate";
import { internalTxnAccountDetail } from "../../../redux/features/internalTransaction/internalTransactionDetailPage";
import { internalTxnViewAll } from "../../../redux/features/internalTransaction/internalTransactionViewAll";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import "./index.css";

const InternalTransactionCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const containerRef = useRef(null);
  const hasAutoFillInteracted = useRef(false);
  const currentAccountDetails = location?.state;
  const reminder_remark =
    currentAccountDetails?.flowType === "ReminderFlow"
      ? currentAccountDetails?.txnDetails?.reminderRemark
      : "";
  const [endDate, setEndDate] = useState({});
  const [isNeft, setIsNeft] = useState(false);
  const [isRtgs, setIsRtgs] = useState(false);
  const [quantity, setQuantity] = useState({});
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [hyperLink, setHyperLink] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [refactor, setRefactor] = useState(false);
  const [autoFill, setAutoFill] = useState(false);
  const [direction, setDirection] = useState(null);
  const [openOwner, setOpenOwner] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [amountInWords, setAmountInWords] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [additionalData, setAdditionalData] = useState({});
  const [refactorTxnData, setRefactorTxnData] = useState([]);
  const [isConfidential, setIsConfidential] = useState(false);
  const [slideAnimation, setSlideAnimation] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [refactorCopyAmt, setRefactorCopyAmt] = useState(false);
  const [showRupeeSymbol, setShowRupeeSymbol] = useState(false);
  const [refactorPasteAmt, setRefactorPasteAmt] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [refactAccDetail, setRefactorAccDetail] = useState(false);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [nextButtonEnabled, setNextButtonEnabled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
  const [showReminderRemark, setShowReminderRemark] = useState(false);
  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);
  const [refactorDestinationAccDetail, setRefactorDestinationAccDetail] =
    useState(false);
  const [refactorConfidentailDetail, setRefactorConfidentailDetail] =
    useState(false);
  const [refactorPaymentMethod, setRefactorPaymentMethod] = useState(false);
  const [refactorTransferAmount, setRefactorTransferAmount] = useState(false);
  const [refactorAdditionalDetail, setRefactorAdditionalDetail] = useState({});
  const [initialRefactorAdditionalDetail, setInitialRefactorAdditionalDetail] =
    useState({});
  const [selectedRadioValue, setSelectedRadioValue] = useState("customname");

  const [copyData, setCopyData] = useState({
    title: "",
    data_type: "",
    value: "",
  });
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: currentAccountDetails?.bank_account_holder_full_name
      ? currentAccountDetails.bank_account_holder_full_name
      : "",
    beneAccountId: currentAccountDetails?.id ? currentAccountDetails?.id : null,
    bankAccountIFSC: currentAccountDetails?.ifsc_code
      ? currentAccountDetails?.ifsc_code
      : "",
    bankAccountNo: currentAccountDetails?.bank_acc_no
      ? currentAccountDetails?.bank_acc_no
      : "",
    amount: "",
    settleType: "",
    bankLogo: currentAccountDetails?.bank_name
      ? currentAccountDetails?.bank_name
      : "",
    labels: [],
    ownerlabels: [],
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    ownerId: null,
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerLastUpdated: null,
    ownerBankLogo: null,
    ownerBankAccountNo: null,
    ownerBankAccountName: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    destinationAccountBalance: 0,
    destinationAcountOwnerId: null,
    isDestinationOwnerActive: true,
    destinationAcountOwnerLastUpdated: null,
  });
  const [beneAccountId, setBeneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );
  const [accountName, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad?.bankAccountNo : "",
  );
  const [panNumber, setPanNumber] = useState(
    txnPayLoad?.pan ? txnPayLoad?.pan : null,
  );
  const [IFSC, setIFSC] = useState(
    txnPayLoad?.bankAccountIFSC ? txnPayLoad?.bankAccountIFSC : "",
  );
  const [bankLogo, setBankLogo] = useState(
    txnPayLoad?.bankLogo ? txnPayLoad?.bankLogo : "",
  );
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );
  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [txnLoading, settxnLoading] = useState(false);
  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  const steps = [
    TEXT.SOURCE_AND_DESTINATION_ACCOUNT,
    TEXT.ADDITIONAL_DETAILS_AND_LABELS,
    TEXT.TRANSFER_AMOUNT,
    TEXT.CONFIRM_AND_CREATE,
  ];

  const services = useSelector((state) => state.refreshToken.services);
  const { beneTransCategories } = useSelector(
    (state) => state.beneAllVerification,
  );

  const { internalTxnDataLoading, internalTxnData } = useSelector(
    (state) => state.internalTxnViewData,
  );

  const { viewInternalAccountDetailData } = useSelector(
    (state) => state.internalAcc,
  );

  let add = GlobalConfiguration?.lengthCheckZero;

  const handleCreateBiller = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    let haveImage = txnPayLoad?.mergeCategory?.some(
      (val) => val?.data_type === "upload" && val?.value !== "Not Given",
    );

    let internalData = {
      amount: txnPayLoad?.amount,
      owner_account_id: txnPayLoad?.ownerId,
      internal_account_id: txnPayLoad?.beneAccountId,
      payment_method: txnPayLoad?.settleType?.toUpperCase(),
      category: txnPayLoad?.selectedCategory?.name,
      confidential_transaction: isConfidential,
      labels: [
        ...(txnPayLoad?.labels || []),
        ...(txnPayLoad?.ownerlabels || []),
      ],
    };

    if (txnPayLoad?.mergeCategory?.length) {
      if (haveImage) {
        const responseUpload = await Promise.all(
          Object.values(uploadedFiles).map((file) =>
            dispatch(uploadImages(file)),
          ),
        );

        internalData.additional_data = {
          data: txnPayLoad?.mergeCategory?.map((fil) => {
            if (fil?.data_type === "toggle") {
              const { description, ...rest } = fil;

              if (fil.value === true) {
                return { ...rest, value: true };
              }
              return { ...rest };
            }
            if (
              fil?.value === "Not Given" ||
              fil?.value === "" ||
              (fil.data_type === "quantity" &&
                fil.value <= GlobalConfiguration?.lengthCheckZero) ||
              (fil.data_type === "multi_select_list" &&
                Array.isArray(fil.value) &&
                fil.value.length === GlobalConfiguration.lengthCheckZero)
            ) {
              const { value, ...rest } = fil;
              return rest;
            }
            if (fil?.data_type === "upload") {
              const { description, ...rest } = fil;
              return { ...rest, value: responseUpload?.[add++]?.payload };
            }

            return fil;
          }),
        };
      } else {
        internalData.additional_data = {
          data: txnPayLoad?.mergeCategory.map((fil) => {
            if (fil?.data_type === "toggle") {
              const { description, ...rest } = fil;

              if (fil.value === true) {
                return { ...rest, value: true };
              }
              return { ...rest };
            }
            if (
              fil?.value === "Not Given" ||
              fil?.value === "" ||
              (fil.data_type === "quantity" &&
                fil.value <= GlobalConfiguration?.lengthCheckZero) ||
              (fil.data_type === "multi_select_list" &&
                Array.isArray(fil.value) &&
                fil.value.length === 0)
            ) {
              const { value, ...rest } = fil;
              return rest;
            }

            return fil;
          }),
        };
      }
    }

    if (services?.includes("CInternalTxn")) {
      const store = await dispatch(
        internalTransactionCreate({ services, navigate, internalData }),
      );

      if (store?.payload?.status === true) {
        if (refactor) {
          dispatch(internalTransactionRecreate(refactorTxnData?.txn_id));
          sessionStorage?.removeItem("recreate_int_txn_id");
        }
        navigate(
          `/internal_transaction_dashboard/create_internal_transaction/success/${store?.payload?.transaction[0]?.txn_id}`,
        );
      } else {
        if (store?.payload?.data?.errors) {
          sessionStorage?.setItem(
            "internalRejected",
            JSON.stringify(store?.payload?.data?.errors),
          );
        } else {
          sessionStorage?.setItem(
            "internalRejected",
            JSON.stringify(store?.payload?.data?.error),
          );
        }
        navigate(
          "/internal_transaction_dashboard/create_internal_transaction/failed",
        );
      }
    } else {
      navigate("/feature_not_assigned");
    }

    dispatch(resetViewAllAcc());
  };

  const buildDuplicateCheckPayload = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    amount: txnPayLoad?.amount,
    payment_method: txnPayLoad?.settleType?.toUpperCase(),
    internal_account_id: txnPayLoad?.beneAccountId,
    owner_account_id: txnPayLoad?.ownerId,
    confidential_transaction: isConfidential
      ? "Show only confidential"
      : !isConfidential
        ? "Hide confidential"
        : undefined,
  });

  const handleNext = async () => {
    if (containerRef?.current) {
      containerRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
    hasAutoFillInteracted.current = false;
    setAutoFill(false);

    if (activeStep === GlobalConfiguration?.lengthCheckTwo) {
      settxnLoading(true);
      setIsSubmitting(true);

      const res = await dispatch(
        internalTxnViewAll(buildDuplicateCheckPayload()),
      );
      const hasDuplicates =
        res?.payload?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero;

      setSimilarTransaction(hasDuplicates);
      setIsSubmitting(false);

      if (hasDuplicates) {
        toast.dismiss();
        CommonToast({
          text: "Few issues found click check to view.",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      setActiveStep((prev) => prev + GlobalConfiguration?.lengthCheckOne);
      setDirection("next");
      settxnLoading(false);
      setRemoveClassName(false);
      setTimeout(
        () => setRemoveClassName(true),
        IntervalConfiguration?.intervalSmall,
      );
    } else if (
      activeStep <
      dataArray.length - GlobalConfiguration?.lengthCheckOne
    ) {
      setActiveStep((prev) => prev + GlobalConfiguration?.lengthCheckOne);
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(
        () => setRemoveClassName(true),
        IntervalConfiguration?.intervalSmall,
      );
    } else {
      if (similarTransaction) {
        setShowSimilarModal(true);
      } else {
        await handleCreateBiller();
      }
    }
  };

  const handleCopyLabels = (prevLabels) => {
    const currentOwnerLabels = txnPayLoad?.ownerlabels || [];

    // Split into owner vs non-owner labels based on what's already known
    const newOwnerLabels = prevLabels.filter((l) =>
      currentOwnerLabels.includes(l),
    );
    const newOtherLabels = prevLabels.filter(
      (l) => !currentOwnerLabels.includes(l),
    );

    setTxnPayLoad((prev) => ({
      ...prev,
      labels: newOtherLabels,
      ownerlabels: newOwnerLabels,
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (activeStep === 3) {
        dispatch(internalTxnViewAll(buildDuplicateCheckPayload()));
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [txnPayLoad]);

  const handleBack = () => {
    if (containerRef?.current) {
      containerRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
    hasAutoFillInteracted.current = false;
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      navigate(-1);
      return;
    }
    setAutoFill(false);
    setActiveStep((prev) => {
      if (prev > GlobalConfiguration?.lengthCheckZero) {
        return prev - GlobalConfiguration?.lengthCheckOne;
      }
      return prev;
    });
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(
      () => setRemoveClassName(true),
      IntervalConfiguration?.intervalSmall,
    );
  };

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const reminderText = reminder_remark
    ? `Reminder remark: ${reminder_remark || "-"}`
    : "";

  const dataArray = steps.map((stepLabel, index) => {
    const isLastStep = index === steps.length - 1;
    const isTxnLoading = isLastStep && isSubmitting;
    const nextButtonText = isLastStep
      ? similarTransaction
        ? "Check"
        : "Create"
      : "Next";

    return {
      ...commonStepperConfig,
      previousText:
        index === GlobalConfiguration?.lengthCheckZero ? "Cancel" : "Previous",
      previousIsDisabled: isTxnLoading,
      nextText: nextButtonText,
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTxnLoading,
      nextIsEnabled: isLastStep ? !isSubmitting : nextButtonEnabled,
      nextEnableBgColor: isLastStep
        ? similarTransaction
          ? "var(--emphasis)"
          : "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
      extraInfoSubText: reminderText,
      extraInfoShow: reminder_remark,
    };
  });

  const renderCreateInternalTxn = () => {
    switch (activeStep) {
      case 0:
        return (
          <InternalTxnSelectAccount
            setSelectedRadioValue={setSelectedRadioValue}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setNextButtonEnabled={setNextButtonEnabled}
            activeStep={activeStep}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            setBeneAccountId={setBeneAccountId}
            accountName={accountName}
            setAccountName={setAccountName}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            panNumber={panNumber}
            setPanNumber={setPanNumber}
            IFSC={IFSC}
            setIFSC={setIFSC}
            bankLogo={bankLogo}
            setBankLogo={setBankLogo}
            category={category}
            setCategory={setCategory}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            setRefactorDestinationAccDetail={setRefactorDestinationAccDetail}
            type={"inter_txn_create"}
            refactor={refactor}
            flow={
              currentAccountDetails?.flowType === "ReminderFlow"
                ? "reminder"
                : "createTxn"
            }
          />
        );
      case 1:
        return (
          <InternalTxnAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            quantity={quantity}
            setQuantity={setQuantity}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            hyperLink={hyperLink}
            setHyperLink={setHyperLink}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            copyData={copyData}
            setCopyData={setCopyData}
            timeData={timeData}
            setTimeData={setTimeData}
            setShowDatePickerCal={(e) => {}}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            reminder_remark={reminder_remark}
            flow={
              currentAccountDetails?.flowType === "ReminderFlow"
                ? "ReminderFlow"
                : "createTxn"
            }
            refactor={refactor}
          />
        );

      case 2:
        return (
          <InternalTxnAmount
            selectedRadioValue={selectedRadioValue}
            setSelectedRadioValue={setSelectedRadioValue}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setNextButtonEnabled={setNextButtonEnabled}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            isRtgs={isRtgs}
            isNeft={isNeft}
            setIsNeft={setIsNeft}
            setIsImps={(e) => {}}
            setIsRtgs={setIsRtgs}
            slideAnimation={slideAnimation}
            setSlideAnimation={setSlideAnimation}
            reminder_remark={reminder_remark}
            flow={
              currentAccountDetails?.flowType === "ReminderFlow"
                ? "ReminderFlow"
                : "createTxn"
            }
            refactor={refactor}
            copyData={copyData}
            setCopyData={setCopyData}
            txnLoading={txnLoading}
          />
        );
      case 3:
        return (
          <InternalTxnConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isConfidential={isConfidential}
            previewImages={previewImages}
            refactor={refactor}
            reminder_remark={reminder_remark}
            showSimilarModal={showSimilarModal}
            setShowSimilarModal={setShowSimilarModal}
            onForceCreate={handleCreateBiller}
            buildDuplicateCheckPayload={buildDuplicateCheckPayload()}
          />
        );
      default:
        return null;
    }
  };

  const renderRecreateInternalTxn = () => {
    switch (activeStep) {
      case GlobalConfiguration?.lengthCheckZero:
        return (
          <RefactorInternalTxnSelectAccount
            internalTxnData={internalTxnData}
            refactAccDetail={refactAccDetail}
            setRefactorAccDetail={setRefactorAccDetail}
            refactorDestinationAccDetail={refactorDestinationAccDetail}
            setRefactorDestinationAccDetail={setRefactorDestinationAccDetail}
            refactorConfidentailDetail={refactorConfidentailDetail}
            setRefactorConfidentailDetail={setRefactorConfidentailDetail}
            refactorPaymentMethod={refactorPaymentMethod}
            setRefactorPaymentMethod={setRefactorPaymentMethod}
            refactorTxnData={refactorTxnData}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setIsConfidential={setIsConfidential}
            isConfidential={isConfidential}
            isNeft={isNeft}
            setIsNeft={setIsNeft}
            isRtgs={isRtgs}
            setIsRtgs={setIsRtgs}
            beneTransCategories={beneTransCategories}
            beneAccountId={beneAccountId}
            setBeneAccountId={setBeneAccountId}
            accountName={accountName}
            setAccountName={setAccountName}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            panNumber={panNumber}
            setPanNumber={setPanNumber}
            IFSC={IFSC}
            setIFSC={setIFSC}
            bankLogo={bankLogo}
            setBankLogo={setBankLogo}
            category={category}
            setCategory={setCategory}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            internalAccData={viewInternalAccountDetailData?.internal_accounts}
            autoFill={autoFill}
            setAutoFill={setAutoFill}
          />
        );

      case GlobalConfiguration?.lengthCheckOne:
        return (
          <InternalTxnRecreateAdditionalDetails
            refactorTxnData={refactorTxnData}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            refactorTransferAmount={refactorTransferAmount}
            setRefactorTransferAmount={setRefactorTransferAmount}
            refactorAdditionalDetail={refactorAdditionalDetail}
            setRefactorAdditionalDetail={setRefactorAdditionalDetail}
            refactorCopyAmt={refactorCopyAmt}
            setRefactorCopyAmt={setRefactorCopyAmt}
            refactorPasteAmt={refactorPasteAmt}
            setRefactorPasteAmt={setRefactorPasteAmt}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setAdditionalData={setAdditionalData}
            additionalData={additionalData}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            setQuantity={setQuantity}
            setSelectedValue={setSelectedValue}
            setStartDateCal={setStartDateCal}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setTimeData={setTimeData}
            autoFill={autoFill}
            setAutoFill={setAutoFill}
            onCopyLabels={handleCopyLabels}
          />
        );

      case GlobalConfiguration?.lengthCheckTwo:
        return (
          <RefactorInternalTxnAmount
            refactorTxnData={refactorTxnData}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            refactorTransferAmount={refactorTransferAmount}
            setRefactorTransferAmount={setRefactorTransferAmount}
            refactorAdditionalDetail={refactorAdditionalDetail}
            setRefactorAdditionalDetail={setRefactorAdditionalDetail}
            refactorCopyAmt={refactorCopyAmt}
            setRefactorCopyAmt={setRefactorCopyAmt}
            refactorPasteAmt={refactorPasteAmt}
            setRefactorPasteAmt={setRefactorPasteAmt}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setAdditionalData={setAdditionalData}
            additionalData={additionalData}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            setQuantity={setQuantity}
            setSelectedValue={setSelectedValue}
            setStartDateCal={setStartDateCal}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setTimeData={setTimeData}
            autoFill={autoFill}
            setAutoFill={setAutoFill}
            setIsRtgs={setIsRtgs}
            setIsNeft={setIsNeft}
            isNeft={isNeft}
            isRtgs={isRtgs}
            refactorPaymentMethod={refactorPaymentMethod}
            setRefactorPaymentMethod={setRefactorPaymentMethod}
            copyData={copyData}
            setCopyData={setCopyData}
          />
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    setTxnPayLoad({
      ...txnPayLoad,
      selectedCategory: beneTransCategories?.categories?.filter((fil) => {
        return fil.name === "Internal";
      })[0],
      mergeCategory: beneTransCategories?.categories?.filter((fil) => {
        return fil.name === "Internal";
      })[0]?.configuration?.data,
    });
  }, [beneTransCategories]);

  useEffect(() => {
    if (!internalTxnDataLoading && refactor) {
      dispatch(
        viewInternalAccountDetail({
          id: internalTxnData?.transaction[0]?.internal_account_id,
        }),
      );
      const initalData = {};
      internalTxnData?.transaction[0]?.additional_data?.data?.forEach(
        ({ name, value, data_type }) => {
          if (data_type === "toggle") {
            initalData[name] = {
              isCopyDirect: value === false ? true : false,
              name: name,
              data: value,
            };
          } else if (
            value !== null &&
            value !== "" &&
            value !== undefined &&
            value?.length !== GlobalConfiguration?.lengthCheckZero
          ) {
            if (
              data_type === "hyperlink" ||
              data_type === "string" ||
              data_type === "numeric"
            ) {
              initalData[name] = {
                isCopyClick: false,
                isPaste: {},
                name: name,
                data: value,
              };
            } else {
              initalData[name] = {
                isCopyDirect: false,
                name: name,
                data: value,
              };
            }
          }
        },
      );
      setInitialRefactorAdditionalDetail(initalData);
      if (internalTxnData?.transaction[0]?.confidential_transaction === "N") {
        setRefactorConfidentailDetail(true);
      }
      setRefactorTxnData(internalTxnData?.transaction[0]);

      const method =
        internalTxnData?.transaction[0]?.payment_method?.toUpperCase();

      // ← ADD THESE - initialize isNeft/isRtgs from prev txn
      setIsNeft(method === "NEFT");
      setIsRtgs(method === "RTGS");

      // your existing flag
      if (method === "NEFT") {
        setRefactorPaymentMethod(true);
      } else if (method === "RTGS") {
        setRefactorPaymentMethod(true);
      }
    }
  }, [internalTxnData, internalTxnDataLoading, refactor]);

  useEffect(() => {
    if (!internalTxnDataLoading && refactor) {
      if (txnPayLoad?.ownerId === refactorTxnData?.owner_account_id) {
        setRefactorAccDetail(true);
      } else {
        setRefactorAccDetail(false);
      }

      if (refactorTxnData?.internal_account_id === txnPayLoad?.beneAccountId) {
        setRefactorDestinationAccDetail(true);
      } else {
        setRefactorDestinationAccDetail(false);
      }
    }
  }, [
    txnPayLoad?.ownerId,
    txnPayLoad?.beneAccountId,
    refactorTxnData,
    internalTxnDataLoading,
    refactor,
  ]);

  useEffect(() => {
    dispatch(beneCategories());
  }, [dispatch]);

  useEffect(() => {
    if (sessionStorage?.getItem("recreate_int_txn_id")) {
      setRefactor(true);
    }

    if (sessionStorage?.getItem("recreate_int_txn_id")) {
      dispatch(
        internalTxnAccountDetail(
          JSON.parse(sessionStorage?.getItem("recreate_int_txn_id")),
        ),
      );
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsStepper(window.innerWidth <= 800);
      setIsMobile(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    const {
      beneAccountId,
      ownerId,
      amount,
      settleType,
      selectedCategory,
      mergeCategory,
    } = txnPayLoad;

    const isStepZeroValid = Boolean(beneAccountId && ownerId);

    const isAmountPresent = !!amount;

    const isRtgsInvalid = isRtgs && amount < 200001;

    const isPaymentMethodInvalid =
      (settleType === "imps" && amount > 200000) ||
      (settleType === "rtgs" && amount <= 200000) ||
      (settleType === "neft" && amount > 200000);

    const isSettleTypeMissing = !settleType;

    const fields = selectedCategory?.configuration?.data || [];

    const mandatoryFields = fields.filter((f) => f.mandatory === "Y");

    const mandatoryFilled =
      mergeCategory?.filter((f) => {
        if (f.mandatory !== "Y") return false;

        if (f.data_type === "multi_select_list") {
          return Array.isArray(f.value) && f.value.length > 0;
        }

        if (f.data_type === "quantity") {
          return typeof f.value === "number" && f.value > 0;
        }

        if (f.data_type === "from_year_to_year") {
          return (
            f.value?.from !== "" &&
            f.value?.from !== undefined &&
            f.value?.to !== "" &&
            f.value?.to !== undefined
          );
        }

        if (f.data_type === "date_range") {
          return (
            f.value?.start_date !== "" &&
            f.value?.start_date !== undefined &&
            f.value?.end_date !== "" &&
            f.value?.end_date !== undefined
          );
        }

        if (f.data_type === "toggle") {
          return f.value === true;
        }

        if (f.data_type === "numeric") {
          return (
            typeof f.value === "number" && !isNaN(f.value) && f.value !== 0
          );
        }

        return !!f.value && f.value !== "" && f.value !== "Not Given";
      })?.length || 0;

    const isMandatoryValid = mandatoryFields.length === mandatoryFilled;

    const hyperlinkFields =
      mergeCategory?.filter(
        (f) => f.data_type === "hyperlink" && f.value !== "",
      ) || [];

    const isHyperlinkValid = hyperlinkFields.every((f) =>
      isValidHttpUrl(f.value),
    );

    const fromToYearFields =
      mergeCategory?.filter(
        (f) => f.data_type === "from_year_to_year" && f.mandatory === "Y",
      ) || [];

    const isFromToYearValid = fromToYearFields.every(
      (f) =>
        f.value?.from !== "" &&
        f.value?.from !== undefined &&
        f.value?.to !== "" &&
        f.value?.to !== undefined,
    );

    let isStepValid = false;

    switch (activeStep) {
      case GlobalConfiguration?.lengthCheckZero:
        isStepValid = isStepZeroValid;
        break;

      case GlobalConfiguration?.lengthCheckOne:
        if (!mandatoryFields.length) {
          isStepValid = true;
        } else {
          const hyperlinkOk =
            hyperlinkFields.length > 0 ? isHyperlinkValid : true;

          const fromToYearOk =
            fromToYearFields.length > 0 ? isFromToYearValid : true;

          isStepValid = isMandatoryValid && hyperlinkOk && fromToYearOk;
        }
        break;

      case GlobalConfiguration?.lengthCheckTwo:
        isStepValid =
          isAmountPresent && !isRtgsInvalid && !isPaymentMethodInvalid;
        break;

      case GlobalConfiguration?.lengthCheckThree:
        isStepValid = !isSettleTypeMissing;
        break;

      default:
        isStepValid = true;
    }
    setNextButtonEnabled(isStepValid);
  }, [
    activeStep,
    txnPayLoad,
    txnPayLoad.mergeCategory,
    isRtgs,
    hyperLink,
    additionalData,
  ]);

  return (
    <>
      {refactor && autoFill && (
        <div
          className={`w-full h-screen bg-Blue-2 justify-center items-center z-z-index-fixed-ui ${isMobile ? "flex" : "hidden"}`}
          style={{
            position: "absolute",
            top: "var(--top-base)",
            left: "var(--left-base)",
            width: "var(--width-full)",
          }}
        >
          <div className="flex flex-col h-full justify-center w-full">
            {autoFill && (
              <div
                className="flex px-padding-sm justify-between"
                style={{
                  width: "var(--width-full)",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "var(--max-content-width)",
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {autoFill && <>{renderRecreateInternalTxn()}</>}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {/* : */}
      {reminder_remark && showReminderRemark && (
        <>
          <div className="w-full-width h-full-height Qsmd:hidden">
            <div className="flex flex-row h-auto w-full bg-primary-nav">
              <div className="p-padding-md">
                <div
                  onClick={() => {
                    setShowReminderRemark(false);
                  }}
                >
                  <SvgComponent
                    url={ICONS?.ARROW_LEFT_WHITE}
                    color={"var(--text-primary)"}
                    height={"var(--icon-md)"}
                    width={"var(--icon-md)"}
                    alt="Arrow"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-gap-xs py-padding-sm">
                <p className="text-font-md text-text-primary font-sans font-normal">
                  {TEXT?.CREATE_TRANSACTION}
                </p>
                <p className="text-font-xs text-text-secondary font-sans font-semibold">
                  {TEXT?.SOURCE_AND_DESTINATION_ACCOUNT}
                </p>
              </div>
            </div>
            <div className="flex flex-col p-padding-md gap-y-gap-sm">
              <p className="text-font-xs text-text-secondary font-sans">
                Reminder remark
              </p>
              <p className="text-font-sm text-text-primary font-sans font-normal pb-padding-xl">
                {reminder_remark}
              </p>
            </div>
            <div
              className="w-width-full h-auto cursor-pointer bottom-bottom-base fixed py-padding-sm flex justify-center items-center bg-text-primary"
              onClick={() => {
                setShowReminderRemark(false);
              }}
            >
              <p className="text-font-md text-primary-nav font-sans font-semibold">
                Back
              </p>
            </div>
          </div>
        </>
      )}
      {/* : ( */}

      <div
        className={`w-width-full ${showReminderRemark ? "hidden Qsmd:flex" : "flex"}  justify-start items-center flex-col bg-primary-bg overflow-hidden h-screen flex`}
      >
        <div className="w-full Qsmd:block hidden lg:bg-transparent bg-primary-nav">
          <div className="h-navbar-breadcrumb-height my-margin-sm Qsmd:my-margin-base"></div>
        </div>

        <div
          className={`flex justify-center items-end w-screen Qsmd:relative fixed bottom-bottom-base left-left-base z-z-index-loader ${
            reminder_remark !== null &&
            currentAccountDetails?.flowType === "ReminderFlow"
              ? "Qsmd:h-topnav-bottom-height Qsmd:min-h-[calc(var(--stepper-height)+var(--padding-xl))] min-h-stepper-height"
              : refactor
                ? "Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height"
                : "min-h-[var(--stepper-moble-height)]"
          }`}
        >
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleNext}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>

        <div
          className={`Qsmd:flex w-full justify-center items-center rounded-b-border-radius-md lg:max-w-tab-width-normal mx-auto relative group top-[calc(var(--negative-global-var)*var(--padding-md))] ${refactor ? "mb-[calc(var(--negative-global-var)*var(--margin-md))]" : ""} ${!reminder_remark ? "bg-primary-card" : ""} ${
            (refactor &&
              (activeStep === GlobalConfiguration?.lengthCheckZero ||
                activeStep === GlobalConfiguration?.lengthCheckOne ||
                activeStep === GlobalConfiguration?.lengthCheckTwo)) ||
            reminder_remark
              ? "Qmd:flex"
              : "hidden"
          } ${activeStep === GlobalConfiguration?.lengthCheckThree && "!hidden"}`}
          style={{
            transition: "height var(--animation-fast) ease",
          }}
        >
          {refactor && (
            <div className="flex flex-col w-full">
              <div
                className={`Qmd:block hidden relative w-width-full py-padding-sm bg-primary-card max-w-tab-width-normal z-z-index-base ${!autoFill ? "group-hover:bg-primary-nav-act" : ""}`}
              ></div>
              <div className="flex flex-col h-full justify-center w-full">
                {/* {autoFill && ( */}
                <div
                  className={`flex ${activeStep === GlobalConfiguration?.lengthCheckOne ? "pl-padding-md" : "px-padding-md"} justify-between`}
                  style={{
                    width: "var(--width-full)",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                      width: "var(--max-content-width)",
                      position: "relative",
                      display: "flex",
                      justifyContent: "flex-start",
                      // alignItems: "center",
                    }}
                  >
                    <div
                      className={`autofill-wrapper w-width-full !hidden Qmd:!flex ${
                        !hasAutoFillInteracted.current
                          ? ""
                          : autoFill
                            ? "openWrap"
                            : "closeWrap"
                      }`}
                    >
                      {renderRecreateInternalTxn()}
                    </div>
                  </div>
                </div>
                {/* )} */}
                {autoFill && (
                  <hr
                    style={{
                      width: "var(--slider-items-seperator-line-width)",
                      maxWidth: "var(--max-content-width)",
                      alignSelf: "center",
                      border: "none",
                      borderTop: "var(--border) solid var(--primary-bg)",
                    }}
                  />
                )}
                <div
                  className="flex items-center h-full justify-center gap-gap-sm py-padding-sm global-hover-white z-z-index-base relative rounded-b-border-radius-md cursor-pointer"
                  style={{
                    display: isMobile ? "none" : "flex",
                  }}
                  onClick={() => {
                    hasAutoFillInteracted.current = true;
                    setAutoFill(!autoFill);
                  }}
                >
                  <p className="text-text-primary text-sm font-normal">
                    Copy or autofill from previous transactions details
                  </p>

                  <SvgComponent
                    url={
                      autoFill ? ICONS?.ARROW_UP_WHITE : ICONS?.ARROW_DOWN_WHITE
                    }
                    color={"var(--text-primary)"}
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                    alt="Arrow"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {isStepper && (
          <>
            <div
              className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-md fixed top-top-base z-z-index-header shadow-box-shadow-bottom"
              style={{ display: autoFill ? "none" : "flex" }}
            >
              <div
                className="cursor-pointer"
                onClick={() => navigate(-1)}
              >
                <SvgComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  color={"var(--text-primary)"}
                  height={"var(--icon-md)"}
                  width={"var(--icon-md)"}
                  alt="Arrow"
                />
              </div>
              <div className="flex flex-col ml-margin-xs pl-padding-xs">
                <div className="text-text-primary text-base">
                  Create Transaction
                </div>
                <div className="text-text-primary text-xs">
                  {steps[activeStep] || ""}
                </div>
              </div>
            </div>
          </>
        )}
        <div
          ref={containerRef}
          className="w-width-full h-auto overflow-y-auto overflow-x-hidden flex-1"
        >
          <div
            className={`${
              reminder_remark
                ? isMobile
                  ? "pt-padding-base"
                  : ""
                : !refactor
                  ? "max-w-screen-lg mx-auto h-full flex flex-col items-center relative w-width-full"
                  : refactor &&
                      activeStep === GlobalConfiguration?.lengthCheckOne
                    ? "Qmd:mb-auto"
                    : (refactor &&
                          activeStep === GlobalConfiguration?.lengthCheckTwo) ||
                        (refactor &&
                          activeStep === GlobalConfiguration?.lengthCheckThree)
                      ? ""
                      : "Qsmd:pt-padding-md Qmd:mb-auto Qsmd:pb-padding-md"
            }`}
          >
            <div
              className={`flex Qsmd:flex-row flex-col w-width-full max-w-tab-width-normal mx-auto ${
                activeStep === GlobalConfiguration?.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClassS
              }`}
            >
              {!isMobile && autoFill && refactor ? (
                <></>
              ) : (
                <div className="h-mobile-create-header w-full Qsmd:hidden block"></div>
              )}
              {renderCreateInternalTxn()}
            </div>
            {(refactor || reminder_remark) && (
              <div className="h-icon-xl w-full Qmd:hidden block"></div>
            )}
            <div className="h-mobile-create-header w-full Qsmd:hidden block"></div>
            <div
              className={`w-full bg-primary-nav-act global-hover-white fixed bottom-bottom-base cursor-pointer z-z-index-header ${!autoFill && refactor && activeStep !== 3 ? "Qmd:hidden block" : "hidden"}`}
            >
              <div
                className="w-full left-left-base"
                onClick={() => {
                  hasAutoFillInteracted.current = true;
                  setAutoFill(!autoFill);
                }}
              >
                <div className="flex justify-between p-padding-md">
                  <p className="font-semibold text-text-primary text-font-xs">
                    Copy or autofill from previous transactions details
                  </p>

                  <SvgComponent
                    url={ICONS?.ARROW_RIGHT_WHITE}
                    color={"var(--text-primary)"}
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                    alt="Arrow"
                  />
                </div>
                <div className="h-stepper-moble-height Qsmd:h-mobile-create-header w-full Qmd:hidden block"></div>
              </div>
            </div>
          </div>
        </div>
        {reminder_remark && isMobile && (
          <div className="fixed w-full bottom-bottom-base z-z-index-fixed-ui flex-flex-col pointer-events-none">
            <div className="w-full-width pointer-events-auto">
              <div
                className="flex flex-row justify-between w-width-full bg-primary-nav-act  p-padding-md  left-left-base global-hover-white relative z-z-index-base cursor-pointer"
                onClick={() => {
                  setShowReminderRemark(true);
                }}
              >
                <p className="text-font-xs text-text-primary font-sans">
                  Reminder remark
                </p>
                <SvgComponent
                  url={ICONS?.ARROW_RIGHT_WHITE}
                  color={"var(--text-primary)"}
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                  alt="Arrow"
                />
              </div>
            </div>
            <div className="h-mobile-create-header w-full Qmd:hidden block"></div>
          </div>
        )}
        <div className="h-stepper-moble-height Qmd:hidden block"></div>
      </div>
      {/* )} */}
    </>
  );
};

export default InternalTransactionCreate;
